export default __webpack_public_path__ + "static/media/waiting.41c2d001.mp3";